import type { FC } from "react";
import { FlatRowDatePanelCell } from "web_myplann/Shared/Components/FlatRow/FlatRowDatePanelCell";
import { getDecadeStart } from "web_myplann/Shared/Components/FlatRow/getDecadeStart";
import { isYearWithinBounds } from "web_myplann/Shared/Components/FlatRow/isYearWithinBounds";

type Props = {
	years: number[];
	decadeStart: number;
	value: number | null;
	minDate?: Date;
	maxDate?: Date;
	onSelect: (year: number) => void;
};

export const FlatRowDateYearList: FC<Props> = ({
	years,
	decadeStart,
	value,
	minDate,
	maxDate,
	onSelect,
}) => (
	<>
		{years.map((year) => (
			<FlatRowDatePanelCell
				key={year}
				label={String(year)}
				selected={year === value}
				outside={getDecadeStart(year) !== decadeStart}
				disabled={!isYearWithinBounds(year, minDate, maxDate)}
				onClick={() => onSelect(year)}
			/>
		))}
	</>
);
